import { useEffect } from "react";
import WidgetErrorBoundary from "../../../../components/widgetErrorBoundary";
import SelectWidget from "../../../../components/widgetLoader/selectWidget";
import { BSWidgetContext } from "../../contexts/bsWidgetContext";
import { useBSDashboardContext } from "../../hooks/useBSDashboardContext";
import { useFetchBSWidgetData } from "../../hooks/useFetchBSWidgetData";

interface BSWidgetLoaderProps {
  widget: {
    url: string;
    type: string;
    [key: string]: any;
  };
  isCurrentlyVisible?: boolean;
  lazyLoadEnabled?: boolean;
}

const BSWidgetLoader = ({
  widget,
  isCurrentlyVisible = true,
  lazyLoadEnabled = false,
}: BSWidgetLoaderProps) => {
  const shouldFetch = !lazyLoadEnabled || isCurrentlyVisible;

  const { data, error, isLoading, mutate } = useFetchBSWidgetData({
    url: widget.url,
    shouldFetch,
  });

  const { addWidgetDataForPrint } = useBSDashboardContext();

  useEffect(() => {
    if (data?.widget?.header_data) {
      addWidgetDataForPrint({ [widget.url]: data.widget });
    }
  }, [data]);

  const reloadData = () => {
    mutate(undefined, { revalidate: true });
  };

  return (
    <WidgetErrorBoundary type={widget.type} url={widget.url}>
      <BSWidgetContext.Provider
        value={{
          widgetData: data,
          dataFetchError: error,
          isFetchingData: isLoading,
          reload: reloadData,
        }}>
        <SelectWidget widgetType={widget.type} />
      </BSWidgetContext.Provider>
    </WidgetErrorBoundary>
  );
};

export default BSWidgetLoader;
